interface Reader {
  /** May change the organization's layer: the permission for every team, which no team role gives. */
  canEditOrganization: boolean;
  /** May read the organization's layer: whoever may read some team's. */
  canReadOrganization: boolean;
  /** The reader's default team, from the session. */
  defaultTeamId: string | undefined;
  /** The teams whose layer the reader may open, in the order the page lists them. */
  teamIds: string[];
}

/**
 * Whose layer a page opens on when its address names none, for the pages that edit the
 * organization's layer and each team's on top of it (the app settings, the report brand):
 * `null` for the organization, a team's id, or `undefined` where the reader may open nothing.
 *
 * Whoever may change the organization's layer starts there. It is theirs alone to change and
 * every team's sits on it, and they are mostly in no team, so the first team of the list is
 * nothing to them. Everybody else starts on their default team, the one whose settings their
 * devices take and whose brand their reports carry; on the first team they may open where
 * that is not one of them; and on the organization, to read, where they may open no team.
 */
export const landingOwner = ({ canEditOrganization, canReadOrganization, defaultTeamId, teamIds }: Reader): string | null | undefined => {
  if (canEditOrganization) return null;
  if (defaultTeamId && teamIds.includes(defaultTeamId)) return defaultTeamId;
  if (teamIds.length > 0) return teamIds[0];

  return canReadOrganization ? null : undefined;
};
